import { render, staticRenderFns } from "./OrderShipmentInfo.vue?vue&type=template&id=43347213&scoped=true&"
import script from "./OrderShipmentInfo.vue?vue&type=script&lang=js&"
export * from "./OrderShipmentInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43347213",
  null
  
)

export default component.exports